import { SemVerString } from './semver.utils';
import { version } from '../package.json'

export { MODEL_VERSION } from 'eplayer-core'

export type ClientVersion =
  |`Jellyfish ${number}.${number}.${number}`
  |`Jellyfish ${SemVerString}-${number}`
  |`JGITVER_VERSION`;

export type ModelVersion = SemVerString

export const APP_VERSION = `Jellyfish ${version}` as ClientVersion
